import React, { useState, useEffect } from "react";
import { json, useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

function LogOut() {
  const navigate = useNavigate();
  const storedToken = localStorage.getItem("token");
  const [open, setOpen] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState("");

  useEffect(() => {
    setOpen(true);
    setOpenConfirmation(false)
  }, []);

  const handleClose = () => {
    setOpen(false);
    navigate("/order-list");
  };

  const handleConfirmation = () => {
    setOpen(false);
    setOpenConfirmation(true)
    // navigate("/order-list");
  };

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/logout?token=${storedToken}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error("Logout Failed");
      }

      const message = data.message;
      if (message == "success") {

        //clear token
        localStorage.setItem('token', "");

        // window.alert("Logout successfully");
        navigate("/login");
      } else {
        handleClose();
        window.alert("Logout Failed");
      }
    } catch (error) {
      console.error("Logout Error:", error);
      handleClose();
      window.alert("Logout Failed");
    }
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{"Are you sure you want to log out?"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Clicking "Yes" will log you out of your account.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmation} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmation}>
        <DialogTitle>{"Logout successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleLogout} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default LogOut;
